import { h, Component } from 'preact';
import { IoIosInformationCircle } from 'react-icons/io';

export const ISI = props => (
    <button name="isi" onClick={ props.onClick } className="isi controlBarButton vjs-control vjs-button">
        <IoIosInformationCircle/>
    </button>
);